import { ActivityCard, ActivityCardSkeleton } from './activity-card'
import type { Activity } from '../types'

interface ActivityGridProps {
  activities: Activity[]
  onToggleSave?: (activity: Activity) => void
  pendingSaveIds?: ReadonlySet<string>
  showSave?: boolean
}

export function ActivityGrid({
  activities,
  onToggleSave,
  pendingSaveIds,
  showSave = true,
}: ActivityGridProps) {
  return (
    <div className="activity-grid">
      {activities.map((activity) => (
        <ActivityCard
          key={activity.id}
          activity={activity}
          onToggleSave={onToggleSave}
          savePending={pendingSaveIds?.has(activity.id)}
          showSave={showSave}
        />
      ))}
    </div>
  )
}

export function ActivityGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="activity-grid" data-testid="activity-grid-loading">
      {Array.from({ length: count }, (_, index) => (
        <ActivityCardSkeleton key={index} />
      ))}
    </div>
  )
}
